<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div>
  <div class="tooltip-container" [class.tooltip-comparison]="comparisonTooltip">
    <div class="tooltip-column">
      <ng-container
        *ngTemplateOutlet="itemTable; context: { $implicit: itemTooltip }"></ng-container>
    </div>
    <div class="tooltip-column" *ngIf="comparisonTooltip">
      <div class="comparison-label" *ngIf="comparisonLabel">{{ comparisonLabel }}</div>
      <ng-container
        *ngTemplateOutlet="itemTable; context: { $implicit: comparisonTooltip }"></ng-container>
    </div>
  </div>
</div>

<ng-template #itemTable let-item>
  <table>
    <tr>
      <td colspan="3">{{ item?.name }}</td>
    </tr>
    <tr>
      <td>Source</td>
      <td colspan="2">{{ getSourceText(item) }}</td>
    </tr>
    <tr *ngIf="isVendorItem(item) && item">
      <td>Vendor</td>
      <td colspan="2">{{ item.itemInstanceId | getVendorIdFromItemId | getVendorName | async }}</td>
    </tr>
    <tr *ngIf="getGearsetName(item) as gearsetName">
      <td>Gearset</td>
      <td colspan="2">{{ gearsetName }}</td>
    </tr>
    <tr *ngIf="getTuningStatName(item) as tuningStatName">
      <td>Tuning</td>
      <td colspan="2">{{ tuningStatName }}</td>
    </tr>
    <tr>
      <td>Current stats:</td>
    </tr>
    <tr *ngFor="let statId of armorStatIds">
      <td>{{ getArmorStatName(statId) }}</td>
      <td>
        <span>{{ getStatWithMasterwork(item, statId) }}</span>
      </td>
      <td>
        <div class="stat-display">
          <div class="stat-display-bar" [style.width]="getWidth((item?.stats || [])[statId] || 0)"
            >&nbsp;</div
          >
          <div
            class="stat-display-bar masterwork"
            [style.width]="getWidth(getMasterworkBonus(item!)[statId])"
            *ngIf="item && getMasterworkBonus(item)[statId] > 0"
            >&nbsp;</div
          >
        </div>
      </td>
    </tr>
    <tr>
      <td>Total base stats:</td>
      <td>
        {{ getTotalStats(item) }}
      </td>
    </tr>
    <tr *ngIf="hasUsedByCount(item)">
      <td colspan="3"
        >Used by {{ getUsedByCount(item) }} generated loadout{{
          getUsedByCount(item) === 1 ? "" : "s"
        }}</td
      >
    </tr>
  </table>
</ng-template>
